import { ICountryDictionaryApi } from '@/types';

export class CountryDictionaryItem {
    id: number;
    name: string;
    iso3: string;

    constructor(data: ICountryDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.iso3 = data.iso3;
    }

    get flagUrl(): string {
        return `/images/flags/countries/${this.iso3}.png`;
    }
}
